<template>
  <div class="homeDia" >
    <div class="mm"   data-scrollbar>
        <p>

            {{$t('sale').text3[0]}}<br>
            <br>
            {{$t('sale').text3[1]}}<br>
            <br>
            {{$t('sale').text3[2]}}

        </p>
    </div>
  </div>
</template>

<script>
  import Scrollbar from 'smooth-scrollbar';
  import {getProductsUrl} from '../util/lang'
  export default {
    name: "aboutDia",
    data(){
      return{
      }
    },
    mounted(){
      Scrollbar.initAll();
    }
  }
</script>

<style lang="scss" scoped>
  .homeDia{
    width:100%;
    margin: 0 auto;
    .mm{
      width:100%;
      height:270px;
       p{
           width:80%;
           margin: 0 auto;
           color:#919191;
           line-height: 30px;
           font-size: 14px;
           font-family: "SourceHanSansSC-Regular";
       }
    }
    @media screen and (max-width: 1000px){
     width:100%;
    }
  }
</style>
<style scoped>
  .html >>> p img{
    width:100%;
    object-fit: cover;
  }
</style>
